import React from "react";
import { Plus, X as XIcon } from "lucide-react";
import FileUploader from "@/components/FileUploader";
import { inputCls, DOC_CATEGORIES } from "./shared";

export default function DocumentList({ docs, onChange, writable }) {
  const update = (idx, patch) => {
    const next = docs.slice();
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };
  const remove = (idx) => onChange(docs.filter((_, i) => i !== idx));
  const add = () =>
    onChange([...docs, { name: "", category: "Supporting", url: "", public_id: "" }]);

  return (
    <div className="space-y-3">
      {docs.length === 0 && (
        <div className="text-[12px] text-[#6b655b] italic">No documents added.</div>
      )}
      {docs.map((d, idx) => (
        <div
          key={idx}
          className="border border-[#e5e0d8] rounded-sm bg-[#f9f8f6]/60 p-4 grid grid-cols-1 md:grid-cols-[1fr_160px_2fr_auto] gap-3 items-start"
          data-testid={`meeting-doc-row-${idx}`}
        >
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#6b655b] font-semibold mb-2">
              Title
            </div>
            <input
              data-testid={`meeting-doc-name-${idx}`}
              className={inputCls}
              placeholder="e.g., Notice for Q2 meeting"
              disabled={!writable}
              value={d.name || ""}
              onChange={(e) => update(idx, { name: e.target.value })}
            />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#6b655b] font-semibold mb-2">
              Category
            </div>
            <select
              data-testid={`meeting-doc-category-${idx}`}
              className={inputCls}
              disabled={!writable}
              value={d.category || "Supporting"}
              onChange={(e) => update(idx, { category: e.target.value })}
            >
              {DOC_CATEGORIES.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>
          <div>
            <FileUploader
              kind="meeting_document"
              label="PDF"
              url={d.url || ""}
              testid={`meeting-doc-file-${idx}`}
              onChange={({ url, public_id }) =>
                update(idx, { url: url || "", public_id: public_id || "" })
              }
            />
          </div>
          {writable && (
            <button
              type="button"
              onClick={() => remove(idx)}
              data-testid={`meeting-doc-remove-${idx}`}
              title="Remove document"
              className="mt-7 inline-flex items-center gap-1 text-[#9e2a2b] hover:bg-[#9e2a2b]/5 px-2 py-1 rounded-sm text-xs"
            >
              <XIcon size={14} strokeWidth={1.5} />
            </button>
          )}
        </div>
      ))}
      {writable && (
        <button
          type="button"
          onClick={add}
          data-testid="meeting-doc-add"
          className="inline-flex items-center gap-2 text-[#234333] border border-[#234333]/30 hover:bg-[#efece6] text-xs px-3 py-1.5 rounded-sm"
        >
          <Plus size={12} strokeWidth={1.5} /> Add document
        </button>
      )}
    </div>
  );
}
